import type { OptimizelyConfig } from '@optimizely/optimizely-sdk';

export interface DecisionIds {
	experimentId?: string;
	variationId?: string;
}

// For flag projects the top-level experimentsMap can miss entries on key collisions, so
// resolve the rule within the flag's own experimentRules/deliveryRules.
export function resolveDecisionIds(
	config: OptimizelyConfig | null,
	flagKey: string,
	ruleKey: string | null,
	variationKey: string | null
): DecisionIds {
	if (!config || !ruleKey) return {};

	const feature = config.featuresMap[flagKey];
	if (!feature) return {};

	const rule = [...feature.experimentRules, ...feature.deliveryRules].find(r => r.key === ruleKey);
	if (!rule) return {};

	return {
		experimentId: rule.id,
		variationId: variationKey != null ? rule.variationsMap[variationKey]?.id : undefined,
	};
}
